module.exports = __webpack_public_path__ + "img/noData.7ae94130.jpg";